module.exports = __webpack_public_path__ + "img/logo.ffea9e4e.png";